import { render, staticRenderFns } from "./success_stories.vue?vue&type=template&id=3955595e&scoped=true&"
import script from "./success_stories.vue?vue&type=script&lang=js&"
export * from "./success_stories.vue?vue&type=script&lang=js&"
import style0 from "./success_stories.vue?vue&type=style&index=0&id=3955595e&scoped=true&lang=scss&"
import style1 from "./success_stories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955595e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3955595e')) {
      api.createRecord('3955595e', component.options)
    } else {
      api.reload('3955595e', component.options)
    }
    module.hot.accept("./success_stories.vue?vue&type=template&id=3955595e&scoped=true&", function () {
      api.rerender('3955595e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/success_stories.vue"
export default component.exports